<button
	cdxButton
	fillStyle="secondaryOutline"
	[chip]="true"
	endSlotSize="extra-small"
	[endSlotActive]="true"
	class="select-trigger"
	(click)="showOptions()"
	data-testId="select-button"
	[checked]="true"
	[inline]="true"
	focusVisibleStyle="dark-dashed"
	#selectTrigger
>
	<span *ngIf="prefixTitle" class="prefix">{{ prefixTitle }}:</span>
	{{ currentOptionText }}
	<cdx-svg-icon [name]="statusIcon | async" size="extra-small" fill="currentColor" end></cdx-svg-icon>
</button>

<ng-template cdkPortal #selectModal="cdkPortal">
	<cdx-slotted-modal size="medium" (close)="onCloseSorterModal()" [verticalPadding]="'medium'">
		<div modal-content class="select-modal">
			<h2 class="title">{{ prefixTitle }}</h2>
			<ul class="sort-options-list">
				<li *ngFor="let option of options; trackBy: trackByOptionValueFn" class="sort-option">
					<input
						type="radio"
						[name]="name"
						[attr.id]="option.value"
						[value]="option.value"
						[(ngModel)]="nextOptionValue"
						(change)="applyChange()"
					/>
					<label [for]="option.value">{{ option.text }}</label>
				</li>
			</ul>
		</div>
	</cdx-slotted-modal>
</ng-template>

<ng-template cdkPortal cdkTrapFocus #selectDropdown="cdkPortal">
	<section class="select-dropdown" role="listbox">
		<ul class="sort-options-list">
			<li *ngFor="let option of options; trackBy: trackByOptionValueFn" class="sort-option">
				<input
					type="radio"
					[name]="name"
					[attr.id]="option.value"
					[value]="option.value"
					[(ngModel)]="nextOptionValue"
					(change)="applyChange()"
				/>
				<label [for]="option.value">{{ option.text }}</label>
			</li>
		</ul>
	</section>
</ng-template>
